import React, { useState, useEffect } from 'react'
import ErrorPage from '../../components/ErrorPage'
import { Alert } from "reactstrap";
import Cotizacion1Diners from "../../components/CotizacionPymes/CotizacionPymesDiners/CotizacionPymesDiners";
import Cotizacion2Diners from "../../components/CotizacionPymes/CotizacionPymesDiners/CotizacionPymes2Diners";
import Cotizacion3Diners from "../../components/CotizacionPymes/CotizacionPymesDiners/CotizacionPlanesDiners";
import CotizacionPlanes from "../../components/CotizacionPymes/CotizacionPymesDiners/CotizacionPlanes";

import Cotizacion4Diners from "../../components/CotizacionPymes/CotizacionPymesDiners/CotizacionPymes4Diners";
import ResumenDiners from "../../components/CotizacionPymes/CotizacionPymesDiners/ResumenPymesDiners";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  ProvinciasPymesFetch,
  FetchMaxCoberturas,
  FetchGirosNegociosPymesDiners,
  CoberturasPymesFetch
} from '../../redux/actions/aRamoPymes'
import { sucursalesFetch } from "../../redux/actions/aRamos";
import {
  urlCiudadesPymes,
  urlCrearCotizacionPymes,
  plataforma1 as plataforma,
  emp as empresa,
  ambienteAplicacion,
  urlRecuperarCotizacionPymes,
  urlResumenPymes,
  urlEditarUbicacionPymes,
  urlEditarCotizacionPymes,
  urlEditarCoberturasPymes
} from '../../constants/urls'
import Page from "../../components/Page";
import { apiPost, apiGet } from '../../api'
import LoadingScreen from 'react-loading-screen'
import logo from "assets/img/logo/logo_aig_login-2.png";
import { PermisosCotizadores } from '../../constants/index';

class ContainerCotizacionPymesDiners extends React.Component {


  constructor(props) {
    super(props)
    this.state = {
      error: '',
      paso: 1,
      arrayCoberturas: [],
      arrayUbicaciones: [],
      ubSelec: 0,
      ubicaciones: 1,
      alert: '',
      Allciudades: [],
      ciudades: [],
      loading: true,
      arrayDatosContratante: '',
      codGiroNegocio: '',
      step: 1,
      sucursalAsesor: this.props.datosAsesor.sucursalCodCore ? this.props.datosAsesor.sucursalCodCore : "001",
      volverResumen: false,
      volverResumenUbicacion: false,
      generalesValues: null,
      deshabilitar: false,
      correoEnviado: false,
      urlPdf: '',
      cargarRecargo: false,
      arraySiniestralidad: []
    }
    this.props.ProvinciasPymesFetch("pymesDiners")

    this.props.FetchGirosNegociosPymesDiners();
    this.props.fethSucursales();
  }


  async componentDidMount() {


    const param = new URLSearchParams(this.props.location.search);
    let id = param.get('id');
    if (id) {
      id = id.replace('?id=', '')
      this.consultarCotizador(id, '', '')
    }

    if (this.props.coberturas && (this.props.coberturas.length > 0) && this.state.codGiroNegocio) this.consultarMaximosCoberturas()
    else this.setState({ loading: false })

  }


  consultarMaximosCoberturas = async (codCobertura) => {
    this.handleLoading(true)
    //console.log('vv', this.state)
    const { codGiroNegocio, idCarrito } = this.state;
    if (!codCobertura && this.props.coberturas) codCobertura = this.props.coberturas[0].codigo
    if (!codGiroNegocio) {
      this.handleLoading(false)
      return
    }


    await this.props.FetchMaxCoberturas({ giroNegocio: codGiroNegocio, codCobertura, idCarrito })

    this.handleLoading(false)
  }


  consultarCoberturas = async () => {

    const { codGiroNegocio, idCarrito } = this.state;
    if (!codGiroNegocio) {
      this.handleLoading(false)
      return
    }

    await this.props.CoberturasPymesFetch({ giroNegocio: codGiroNegocio })
    this.handleLoading(false)

  }


  consultarCoberturas = async () => {

    const { codGiroNegocio, idCarrito } = this.state;
    if (!codGiroNegocio) {
      this.handleLoading(false)
      return
    }

    await this.props.CoberturasPymesFetch({ giroNegocio: codGiroNegocio })

    this.handleLoading(false)

  }

  handleLoading(loading) {
    this.setState({ loading })
  }


  consultarCotizador = async (id, editar, regresaResumen) => {

    //console.log("🟡 Ejecutando consultarCotizador con parámetros:", { id, editar, regresaResumen });
    const { volverResumen } = this.state
    let url = urlRecuperarCotizacionPymes
    // console.log('editar', editar, regresaResumen)
    if (editar === 'ubicacion') {
      url = urlEditarUbicacionPymes
      this.props.ProvinciasPymesFetch("pymesDiners")
    }
    if (editar === 'anadirUbicacion') {
      url = urlEditarCotizacionPymes
      this.props.ProvinciasPymesFetch("pymesDiners")
    } else if (editar === 'cotizacion') {
      url = urlEditarCotizacionPymes
    } else if (editar === 'cobertura') {
      url = urlEditarCoberturasPymes
    }

    //console.log("🔄 Consultando carrito en:", url + id);

    const res = await apiGet(url + id)

    if (res.codGiroNegocio) {
      await this.props.CoberturasPymesFetch({ giroNegocio: res.codGiroNegocio })
    }

    if (res.carRecotizacion) {
      this.setState({ deshabilitar: true })
    } else {
      this.setState({ deshabilitar: false })
    }

    if (res.carUrlPdf) {
      this.setState({ carUrlPdf: res.carUrlPdf })
    }


    if (res.carCorreoRecotizacionEnviado == null || res.carCorreoRecotizacionEnviado == false) {
      this.setState({ correoEnviado: false })
    } else {
      this.setState({ correoEnviado: true })
    }

    // console.log('ressss', res)

    if (res.generales) {
      this.setState({ generalesValues: res.generales })
    }


    this.setState({ volverResumen: editar === 'anadirUbicacion' ? false : res.resumen ? true : false })
    if (editar === 'anadirUbicacion') {
      this.setState({ volverResumenUbicacion: true })
    } else {
      if (editar != 'anadirUbicacion') {
        this.setState({ volverResumenUbicacion: false })
      }
    }

    const { transaccion, errorDescripcion, arrayCoberturas } = res
    if (transaccion) {
      let { search } = this.props.location
      const param = new URLSearchParams(search);
      let paso = parseInt(param.get('paso'));
      paso = paso ? paso : res.paso
      //validar que viene de facturacion
      let backfacturacion = param.get('back')
      if (backfacturacion && backfacturacion !== "" && backfacturacion !== null && backfacturacion !== undefined) {
        paso = backfacturacion
      }
      if (regresaResumen !== '') {
        paso = regresaResumen
        this.setState({ resumen: res.resumen })
      }
      //Validar el paso si son ediciones
      if (editar !== '' && editar === 'ubicacion') {
        paso = 2;
      }
      if (editar !== '' && editar === 'anadirUbicacion') {
        paso = 1;
      } else if (editar !== '' && editar === 'cotizacion') {
        this.setState({ volverResumen: true })
        paso = 5;
      } else if (editar !== '' && editar === 'cobertura') {
        this.setState({ volverResumen: true })

        paso = 3;
      } else if (paso === 4) {
        this.setState({ resumen: res.resumen })
      } else if (editar !== '' && editar === 'resumen') {
        this.setState({ volverResumen: true })
        paso = 'resumen';
      }
      if (paso === 7 || paso === '7') {
        //Agregado para el resumen cuando se recupera la cotizacion
        this.props.history.replace({
          pathname: '/datos-facturacion',
          search: `id=${id}`,
        })
      } else {
        //Funciona correctamente
        // console.log("EL PASO ES "+ paso)
        this.props.history.replace({
          pathname: '/pymesDiners/cotizador',
          search: `paso=${paso}&id=${id}`,
        })
      }

      let arrayUbicaciones = res.arrayUbicaciones
      if (!arrayUbicaciones) {
        arrayUbicaciones = this.creararrayUbicaciones(res.numUbicaciones)
      }
      if (res.giroNegocio && res.giroNegocio !== undefined && res.giroNegocio !== '') {
        this.setState({ codGiroNegocio: res.giroNegocio })
      }
      await this.consultarMaximosCoberturas('incendioAliadas')

      this.setState({ ...res, idCarrito: id, ubicaciones: res.numUbicaciones, arrayUbicaciones, paso })
    } else {
      this.setState({ error: errorDescripcion || true })
    }

  }

  creararrayUbicaciones = ubicaciones => {
    let { arrayUbicaciones } = this.state
    if (arrayUbicaciones.length < ubicaciones)
      for (let i = (arrayUbicaciones.length); i < ubicaciones; i++) {
        arrayUbicaciones.push('');
      }
    else if (arrayUbicaciones.length > ubicaciones) {
      arrayUbicaciones = arrayUbicaciones.slice(0, ubicaciones)
    }
    return arrayUbicaciones
  }
  handleResumen = async () => {

    const url = urlResumenPymes + this.state.idCarrito
    try {

      let res = await apiGet(url)

      //console.log("🟡 Resultado del resumen desde el backend:", res);
      if (res.transaccion) {
        this.setState({ resumen: { ...res }, step: 2 })
        this.consultarCotizador(this.state.idCarrito, 'resumen', '')
        // this.props.history.replace({
        //   pathname: '/pymes/cotizador',
        //   search: `paso=resumen&id=${this.state.idCarrito}`,
        // })
      } else {
        this.setState({ alert: res.errorDescripcion })
        setTimeout(() => {
          this.setState({ alert: '' })
        }, 5000);
      }
      window.scroll(0, 0)

    } catch (error) {

    }
  }
  handleNext = async ({
    planSeleccionado,
    planSelecionadoResponse,
    ubicaciones,
    codGiroNegocio,
    arrayDatosContratante,
    arrayCoberturas,
    adicional,
    sucursalAsesor
  }) => {

    /*console.log("🟢 Datos recibidos en handleNext:");
    console.log({
      planSeleccionado,
      planSelecionadoResponse,
      ubicaciones,
      codGiroNegocio,
      arrayDatosContratante,
      arrayCoberturas,
      adicional,
      sucursalAsesor
    });
*/


    let { paso, volverResumen } = this.state
    this.toggleLoading()
    let guardar = {}

    //console.log("PASOOOOO", paso)
    if (paso === 1) {
      //Crear Nodo carDatosAsesor
      let arrayDatosAsesor = {
        nombre: `${this.props.datosAsesor.nombres} ${this.props.datosAsesor.apellidos}`,
        codigoCore: this.props.datosAsesor.cliCodigoCore,
        sucursalSeleccionada: sucursalAsesor,
        ambiente: ambienteAplicacion,
        emailAsesor: this.props.datosAsesor.correo ? this.props.datosAsesor.correo : '',
        brokerRUC: this.props.datosAsesor.brokerRUC ? this.props.datosAsesor.brokerRUC : '',
        brokerNombre: this.props.datosAsesor.brokerNombre ? this.props.datosAsesor.brokerNombre : '',
        brokerCodigo: this.props.datosAsesor.brokerCodigo ? this.props.datosAsesor.brokerCodigo : '',
      }
      let codProducto = "pymesDiners";

      const r = await this.guardarPasos({
        codProducto,
        codGiroNegocio,
        numUbicaciones: ubicaciones,
        arrayDatosContratante,
        paso,
        adicional,
        arrayDatosAsesor
      })
      if (r) {
        if (this.props.dataPymes.hasError)
          this.setState({ alert: this.props.dataPymes.hasError })

        const arrayUbicaciones = this.creararrayUbicaciones(ubicaciones)
        guardar = { ubicaciones, codGiroNegocio, arrayUbicaciones, ubSelec: 0, arrayDatosContratante }
      }

    } else if (paso === 3) {

      await this.handleResumen();
      guardar = { planSeleccionado, planSelecionadoResponse, carUrlPdf: planSelecionadoResponse.urlPdf };
    } else if (paso === 'resumen') {

      await this.consultarMaximosCoberturas()
      if (this.props.dataPymes.maxCoberturas.length <= 0) return

      const r = await this.guardarPasos({ arrayCoberturas, paso: "resumen" })
      guardar = { arrayCoberturas }

    }
    window.scroll(0, 0)

    this.setState({ loading: false, ...guardar })
  }
  toggleLoading = () => this.setState((prevState) => ({ ...prevState, loading: !prevState.loading }))

  handleBack = () => {
    const { ubSelec, paso } = this.state;
    if (paso === 2 && ubSelec > 0) {
      return this.setState({ ubSelec: ubSelec - 1 })
    }
    const param = new URLSearchParams(this.props.location.search);
    let id = param.get('id');

    this.props.history.push({
      pathname: '/pymesDiners/cotizador',
      search: `paso=${paso - 1}&id=${id}`,
    })

  }

  getCiudades = async (idProv) => {

    this.setState({ loading: true })
    const { Allciudades } = this.state
    if (idProv === '') {
      const { provincias } = this.props.dataPymes
      idProv = provincias[0].id
    }
    const encuentra = Allciudades.find(({ id }) => id === idProv)
    if (!encuentra) {
      try {
        const { transaccion, ciudades } = await fetch(urlCiudadesPymes + idProv).then(response => response.json())
        if (transaccion && ciudades && ciudades.length > 0) {
          let data = []
          ciudades.forEach(({ ciuNombre: name, id, provCodigo, provNombre }) => data.push({
            id,
            name,
            provCodigo,
            provNombre
          }));
          Allciudades.push({ id: idProv, ciudades: data })
          this.setState({ loading: false, Allciudades, ciudades: data })
        } else {
          this.setState({ loading: false, alert: 'Error buscando ciudades, seleccione otra ciudad' });
        }

      } catch (error) {
        this.setState({ loading: false, alert: 'Error consultando ciudades' });
      }
    } else {
      const { ciudades } = encuentra
      this.setState({ loading: false, ciudades })
    }
  }

  setPlanSeleccionado = (plan) => {
    //console.log("✅ Plan recibido en el padre:", plan);
    // Guardar en el state si lo necesitás
    this.setState({ planSeleccionado: plan });
  };

  guardarPasos = async ({
    planSeleccionado,
    planSelecionadoResponse,
    arraySiniestralidad = [],
    codProducto,
    codGiroNegocio,
    numUbicaciones = 1,
    arrayDatosContratante,
    arrayCoberturas,
    adicional,
    arrayDatosAsesor
  }) => {
    const { cliCodigoCore } = this.props
    const { paso, idCarrito: id } = this.state


    const param = {
      empresa,
      plataforma,
      paso,
      cliCodigoCore,
      codGiroNegocio,
      numUbicaciones,
      arrayDatosContratante,
      idCarrito: id,
      arrayCoberturas,
      ambiente: ambienteAplicacion,
      adicional,
      arraySiniestralidad,
      arrayDatosAsesor, codProducto,
      planSeleccionado,
      planSelecionadoResponse
    }

    const { transaccion, idCarrito, errorDescripcion } = await apiPost(urlCrearCotizacionPymes, param)

    if (transaccion) {
      if (paso === 1) this.setState({ idCarrito: idCarrito ? idCarrito : id, adicional });
      if (paso === 'resumen') {
        this.setState({ idCarrito: idCarrito ? idCarrito : id, adicional })
        return true;
      }
      this.props.history.push({
        pathname: '/pymesDiners/cotizador',
        search: `paso=${paso + 1}&id=${this.state.idCarrito}`,
      })
      return true
    } else {
      alert(errorDescripcion)
    }
    return false
  }

  guardarUbicacion = async (data, i, regresarResumen, volverresumenpaso3) => {
    let { arrayUbicaciones, idCarrito } = this.state
    const ubicacionesAnteriores = [...arrayUbicaciones]

    arrayUbicaciones[i] = data
    ubicacionesAnteriores[i] = { ...ubicacionesAnteriores[i], ...data }
    let ubSelec = 0
    let siguiente = ''

    for (let i = 0; i < arrayUbicaciones.length; i++) {
      const data = arrayUbicaciones[i];

      if (!data) {
        siguiente = i;
        ubSelec = i
        break
      }
    }

    const arrayUbi = arrayUbicaciones.filter((data) => (data !== ''));

    const { cliCodigoCore } = this.props

    const param = {
      empresa,
      plataforma,
      paso: 2,
      codProducto: 'pymesDiners',
      cliCodigoCore,
      arrayUbicaciones: arrayUbi,
      idCarrito,
      resumen: regresarResumen || this.state.volverResumenUbicacion,
      ubicacionesAnteriores: ubicacionesAnteriores,
      ubicacionActual: i
    }
    //return console.log('arrayUbicaciones',param)
    const res = await apiPost(urlCrearCotizacionPymes, param)

    if (res.transaccion) {
      if (!siguiente && siguiente !== 0) {
        this.setState({ arrayUbicaciones: ubicacionesAnteriores })
        // console.log('resumen', regresarResumen)
        if (regresarResumen === true) {

          this.consultarCotizador(this.state.idCarrito, 'cobertura', '')
        } else {
          this.props.history.push({
            pathname: '/pymesDiners/cotizador',
            search: `paso=${3}&id=${this.state.idCarrito}`,
          })
        }

      } else this.setState({ arrayUbicaciones: ubicacionesAnteriores, ubSelec })
    } else alert(res.errorDescripcion)

    window.scrollTo(0, 0)

  }

  componentDidUpdate(prevProps, prevState) {


    const { ubSelec, arrayUbicaciones } = this.state
    if (ubSelec !== prevState.ubSelec && arrayUbicaciones[ubSelec]) {
      this.getCiudades(arrayUbicaciones[ubSelec].provincia ? arrayUbicaciones[ubSelec].provincia : '')
    }


    if (this.props.coberturas && prevProps.coberturas !== this.props.coberturas) {

      this.consultarMaximosCoberturas();
    }
    let { search } = this.props.location
    if (search !== prevProps.location.search) {
      const param = new URLSearchParams(search);
      let paso = parseInt(param.get('paso'));
      if (isNaN(paso)) paso = param.get('paso')
      this.setState({ paso })
    }
  }

  redireccionarFacturacion = () => {
    this.props.history.push({
      pathname: "/datos-facturacion",
      search: `?id=${this.state.idCarrito}`
    });
  }

  editarValoresUbicacion = () => {
    let id = this.state.idCarrito
    this.consultarCotizador(id, 'ubicacion', '')
  }

  editarValoresCotizacion = () => {
    this.consultarCotizador(this.state.idCarrito, 'cotizacion', '')
  }

  editarCoberturas = () => {
    this.consultarCotizador(this.state.idCarrito, 'cobertura', '')
  }

  anadirUbicacion = () => {
    this.consultarCotizador(this.state.idCarrito, 'anadirUbicacion', '')
  }

  render() {
    if (this.state.error)
      return <ErrorPage mainText='Lo sentimos!! No hemos podido encontrar la página que está buscando.'
        secondaryText={this.state.error} />

    const { maxCoberturas } = this.props
    let arraySucursales = [];
    this.props.sucursales.map(s => {
      arraySucursales.push({ id: s.sucCodigoCore, name: s.sucNombre });
    });

    const { pathname } = this.props.location
    const {
      paso,
      arrayUbicaciones,
      ubSelec,
      ubicaciones,
      codGiroNegocio,
      alert,
      Allciudades,
      ciudades,
      loading,
      arrayDatosContratante,
      arrayCoberturas,
      pymesCampoAdicional,
      step,
      sucursalAsesor,
      volverResumen
    } = this.state
    // console.log("fff", maxCoberturas)
    //this.consultarUrl();
    // console.log("ggg", this.state.arrayDatosContratante)

    // return view
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <LoadingScreen
              loading={loading || this.props.dataPymes.isLoading || this.props.isLoadingPersoneria}
              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text="Cargando..."
            >

                                            <Page title="Cotización Pyme Protect"
                                                  breadcrumbs={[{name: "Cotización Pyme Protect", active: true}]}>
                                                <div>
                                                    <div className="contenedor-pasos">
                                                        <div className="wrapper-step">
                                                            <div className="arrow-steps clearfix-step">
                                                                <div
                                                                    className={step === 1 ? "step current" : "step"}> {` 1. Cotización `} </div>
                                                                <div
                                                                    className={step === 2 ? "step current" : "step"}> {` 2. Resumen `} </div>
                                                                <div
                                                                    className={step === 3 ? "step current" : "step"}> {` 3. Confirmación `} </div>
                                                                <div class="step"> {` 4. Forma de Pago `} </div>
                                                                <div
                                                                    class="step"> {` 5. Formulario de Vinculación `} </div>
                                                                <div class="step"> {` 6. Emisión `} </div>
                                                            </div>
                                                        </div>
                                                    </div>

                  {alert && <Alert
                    color="danger">{` ${alert}, recargue la página o intente nuevamente `}</Alert>}


                                                    {paso === 1 &&
                                                        <div >
                                                            <Cotizacion1Diners
                                                                handleNext={this.handleNext}
                                                                ubicaciones={ubicaciones}
                                                                codGiroNegocio={codGiroNegocio}
                                                                arrayDatosContratante={arrayDatosContratante}
                                                                adicional={pymesCampoAdicional}
                                                                arraySucursales={arraySucursales}
                                                                datosAsesor={this.props.datosAsesor}
                                                                sucursalAsesor={sucursalAsesor}
                                                            />
                                                        </div>
                                                    }


                  {paso === 2 &&
                    <div className='container-body-spaces' style={{ marginTop: 10, }}>
                      <div className='flex container-body-spaces'
                        style={{ flexWrap: 'wrap', }}> {arrayUbicaciones.map((data, i) => {
                          let clase = 'botontabs'
                          if (!data && ubSelec !== i) clase = `${clase} disabledAll`
                          if (ubSelec === i) clase = `botontabsSelected ${clase}`

                          return <div key={'botonesUbicacion' + i}
                            className={clase}
                            onClick={() => !data ? console.log('') : this.setState({ ubSelec: i })}> {` Ubicación ${i + 1}`} </div>
                        }
                        )}
                      </div>
                    </div>
                  }
                  {paso === 2 && arrayUbicaciones.map((data, i) => <div
                    key={`ubicacion${i}`}
                    className={ubSelec === i ? '' : 'divUbicacion'}>
                    <Cotizacion2Diners key={'Cotizaciones' + i}
                      data={data}
                      codProducto="pymesDiners"
                      NumUbicacion={i + 1}
                      handleNext={this.handleNext}
                      Allciudades={Allciudades}
                      ciudades={ciudades}
                      getCiudades={this.getCiudades}
                      guardarUbicacion={this.guardarUbicacion}
                      handleBack={this.handleBack}
                      volverResumen={volverResumen}
                      limites={this.props.dataPymes.limites}
                    /></div>)
                  }
                  {paso === 3 &&                           /* <Cotizacion3Diners
                              id={this.state.idCarrito}
                              handleNext={this.handleNext}
                              handleBack={this.handleBack}
                              coberturas={this.props.coberturas}
                              arrayCoberturas={arrayCoberturas}
                              fetchMaximos={this.consultarMaximosCoberturas} />*/
                    <CotizacionPlanes
                      idCarrito={this.state.idCarrito}
                      handleNext={this.handleNext}
                      handleBack={this.handleBack}
                      setPlanSeleccionado={this.setPlanSeleccionado}
                      codigoProducto="pymesDiners"
                      codGiroNegocio={this.state.codGiroNegocio}
                    />

                  }
                  {paso === 4 &&
                    <ResumenDiners
                      resumen={this.state.resumen}
                      idCarrito={this.state.idCarrito}
                      planSelecionadoResponse={this.state.planSelecionadoResponse}
                      redireccionar={this.redireccionarFacturacion}
                      editarUbicacion={this.editarValoresUbicacion}
                      editarCotizacion={this.editarValoresCotizacion}
                      editarCoberturas={this.editarCoberturas}
                      anadirUbicacion={this.anadirUbicacion}
                      deshabilitar={this.state.deshabilitar}
                      carUrlPdf={this.state.carUrlPdf}
                      correoEnviado={this.state.correoEnviado}
                      setCorreoEnviado={(value) => {
                        this.setState({ correoEnviado: value })
                      }}
                      setCargarRecargo={(value) => {
                        this.setState({ cargarRecargo: value })
                      }}
                    />
                  }

                  {`${paso}` === 'resumen' && this.state.resumen &&
                    <ResumenDiners
                      resumen={this.state.resumen}
                      idCarrito={this.state.idCarrito}
                      planSelecionadoResponse={this.state.planSelecionadoResponse}
                      redireccionar={this.redireccionarFacturacion}
                      editarUbicacion={this.editarValoresUbicacion}
                      editarCotizacion={this.editarValoresCotizacion}
                      editarCoberturas={this.editarCoberturas}
                      anadirUbicacion={this.anadirUbicacion}
                      deshabilitar={this.state.deshabilitar}
                      carUrlPdf={this.state.carUrlPdf}
                      correoEnviado={this.state.correoEnviado}
                      setCorreoEnviado={(value) => {
                        this.setState({ correoEnviado: value })
                      }}
                      setCargarRecargo={(value) => {
                        this.setState({ cargarRecargo: value })
                      }}
                    />
                  }
                </div>
              </Page>
            </LoadingScreen>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  dataPymes: state.dataPymes,
  coberturas: state.dataPymes.coberturas,
  maxCoberturas: state.dataPymes.maxCoberturas,
  cliCodigoCore: state.datosUsuarios.dataUsuario.cliCodigoCore,
  isLoadingPersoneria: state.catalogosCotizacion.personeria.isLoading,
  dataUsuario: state.datosUsuarios,
  datosAsesor: state.datosUsuarios.dataUsuario,
  sucursales: state.datosSucursales.DataSucursales,
});

const mapDispatchToProps = dispatch => {
  return {
    ProvinciasPymesFetch: () => dispatch(ProvinciasPymesFetch()),
    FetchGirosNegociosPymesDiners: () => dispatch(FetchGirosNegociosPymesDiners()),
    FetchMaxCoberturas: (data) => dispatch(FetchMaxCoberturas(data)),
    CoberturasPymesFetch: (data) => dispatch(CoberturasPymesFetch(data)),
    fethSucursales: () => dispatch(sucursalesFetch()),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerCotizacionPymesDiners)
);